import { TypedDocumentNode, gql } from '@apollo/client';

import { getAnyPositionInitials_AnyPlayerInterface } from './__generated__/getAnyPositionInitials.graphql';
import { isType, withFragments } from './gql';
import { getPositionInitials } from './positions';

export const getAnyPositionInitials = withFragments(
  (player: getAnyPositionInitials_AnyPlayerInterface) => {
    if (isType(player, 'NBAPlayer') || isType(player, 'BaseballPlayer')) {
      return getPositionInitials(player.anyPositions[0]);
    }
    return player?.anyPositions[0].slice(0, 3);
  },
  {
    AnyPlayerInterface: gql`
      fragment getAnyPositionInitials_AnyPlayerInterface on AnyPlayerInterface {
        slug
        anyPositions
      }
    ` as TypedDocumentNode<getAnyPositionInitials_AnyPlayerInterface>,
  }
);
